import Helpers from "@/Helpers";
import { renderFormattedContent } from "@/utils/renderFormattedContent";

export default function Welcome(props) {
  // Add null checking before destructuring
  if (!props || !props.sectionData) {
    console.error('Welcome: props or props.sectionData is undefined', { props });
    return null;
  }

  const { testState, lang, currentSection } = props.sectionData;
  const sectionContent = Helpers.getSectionContent(currentSection, lang);
  const content = String(Helpers.getSectionHtmlValue(sectionContent, "instructions") || "");

  if (!content) return null;
  return (
    <>
      {testState ? (
        <div className="Intro Welcome">
          <div className="content">
            {renderFormattedContent(content)}
          </div>
        </div>
      ) : null}
    </>
  );
}